import {
	MimaText,
	MimaInput,
	ReceiptCheckBox as RCB,
	MimaButton,
	MimaDropdown,
	FlexButton,
	Modal,
} from '../../components';
import {
	EditEmployeeContainer,
	PermissionListContainer,
} from '../../containers';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import Avatar from '../../assets/img/Mima-avatar.png';
import { amountFormatter } from '../../utils/utils';
import { MdModeEditOutline } from 'react-icons/md';
import { userStore } from '../../stores';
import { Formik } from 'formik';
import moment from 'moment';
import { toJS } from 'mobx';
import React from 'react';

const SpecificEmployee = ({
	employee,
	onSubmit,
	loading,
	validationSuspensionSchema,
	validationTerminationSchema,
	suspension,
	terminateStatus,
	showPersonalInfo,
	employeeDeductions,
	showJobInfo,
	closeModal,
	showBankDetails,
	deductions,
	showDeductions,
	personalInfo,
	jobInfo,
	bankDetails,
	editState,
	goToEditState,
	terminate,
	showTerminate,
	terminate2,
	next,
	success,
	stage2,
	stage3,
	showStage2,
	showStage3,
	showEditSuccess,
	showStage1,
	goBack,
	showLoans,
	loans,
	showEmployeeAdmin,
	makeAdmin,
}) => {
	const permissions = new Set(
		toJS(userStore.user?.permissions?.map(perm => perm.name))
	);

	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			{!editState &&
				!terminate &&
				!terminate2 &&
				!suspension &&
				!success &&
				!makeAdmin && (
					<>
						<div
							className={styles.employee__editButton}
							onClick={goToEditState}>
							<MdModeEditOutline />
							<MimaText color="var(--color-primary)">Edit</MimaText>
						</div>
						<div className={styles.employee__avatar_container}>
							<img
								src={Avatar}
								alt="Employee"
								className={styles.employee__avatar}
							/>
						</div>
						{employee.status}
						<MimaText variant="subtitle" mb={4}>
							{`${employee.user.firstname} ${employee.user.lastname}`}
						</MimaText>
						<FlexButton
							title="Personal Information"
							mb={2}
							onClick={showPersonalInfo}
						/>
						{personalInfo && (
							<div className={styles.employee__details}>
								<MimaText labelTitle="Employee Name" mb={2}>
									{`${employee.user.firstname} ${employee.user.lastname}`}
								</MimaText>
								<MimaText labelTitle="Phone Number" mb={2}>
									{employee.user.mobile}
								</MimaText>
								<MimaText labelTitle="Gender" mb={2}>
									{employee.user.gender}
								</MimaText>
								<MimaText labelTitle="Email address" mb={2}>
									{employee.user.email}
								</MimaText>
							</div>
						)}
						<FlexButton title="Job Information" mb={2} onClick={showJobInfo} />
						{jobInfo && (
							<div className={styles.employee__details}>
								<MimaText labelTitle="Start Date" mb={2}>
									{employee.startDate ? employee.startDate : 'Not Set'}
								</MimaText>
								<MimaText labelTitle="Employment Type" mb={2}>
									{employee.employmentType}
								</MimaText>
								<MimaText labelTitle="Settlement Type" mb={2}>
									{employee.settlementCycle}
								</MimaText>
								<MimaText labelTitle="Job Title" mb={2}>
									{employee.jobTitle}
								</MimaText>
								<MimaText labelTitle="Department" mb={2}>
									{employee.department?.name}
								</MimaText>
								<MimaText labelTitle="Expected Gross Pay" mb={2}>
									{amountFormatter().format(employee.grossPay)}
								</MimaText>
								<MimaText labelTitle="Expected Net Pay" mb={2}>
									{amountFormatter().format(employee.netPay || 0)}
								</MimaText>
								<MimaText labelTitle="Paye Tax" mb={2}>
									{amountFormatter().format(employee.tax || 0)}
								</MimaText>
								<MimaText labelTitle="Pension" mb={2}>
									{amountFormatter().format(employee.pension || 0)}
								</MimaText>
								<MimaText labelTitle="NHF" mb={2}>
									{amountFormatter().format(employee.nhf || 0)}
								</MimaText>
								<MimaText labelTitle="WHT" mb={2}>
									{amountFormatter().format(employee.wht || 0)}
								</MimaText>
								<MimaText labelTitle="Other Deduction" mb={2}>
									{amountFormatter().format(employee.otherDeductionAmount || 0)}
								</MimaText>
								{employee.employmentType === 'FULLTIME' &&
									employee.basicSalary > 0 && (
										<>
											<MimaText labelTitle="Basic Salary" mb={2}>
												{amountFormatter().format(employee.basicSalary || 0)}
											</MimaText>
											<MimaText labelTitle="House Allowance" mb={2}>
												{amountFormatter().format(
													employee.housingAllowance || 0
												)}
											</MimaText>
											<MimaText labelTitle="Transportation Allowance" mb={2}>
												{amountFormatter().format(
													employee.transportAllowance || 0
												)}
											</MimaText>
											<MimaText labelTitle="Meal Allowance" mb={2}>
												{amountFormatter().format(employee.mealAllowance || 0)}
											</MimaText>
											<MimaText labelTitle="Utility Allowance" mb={2}>
												{amountFormatter().format(
													employee.utilityAllowance || 0
												)}
											</MimaText>
											<MimaText labelTitle="Entertainment Allowance" mb={2}>
												{amountFormatter().format(
													employee.entertainmentAllowance || 0
												)}
											</MimaText>
										</>
									)}
							</div>
						)}
						<FlexButton title="Bank Details" mb={2} onClick={showBankDetails} />
						{bankDetails && (
							<div className={styles.employee__details}>
								<MimaText labelTitle="Account Name" mb={2}>
									{employee.withdrawalBankAccount?.accountName}
								</MimaText>
								<MimaText labelTitle="Account Number" mb={2}>
									{employee.withdrawalBankAccount?.accountNumber}
								</MimaText>
								<MimaText labelTitle="Bank Name" mb={2}>
									{employee.withdrawalBankAccount?.bank}
								</MimaText>
							</div>
						)}
						<FlexButton title="Deductions" mb={2} onClick={showDeductions} />
						{deductions && (
							<div className={styles.employee__details}>
								{employeeDeductions.map((deduct, key) => (
									<MimaText key={key} mb={2}>
										{deduct}
									</MimaText>
								))}
								<MimaText mb={2}>
									{ `Other Deductions: ${employee.otherDeductionAmount > 0 ? 'Yes' : 'No'}`  }
								</MimaText>
							</div>
						)}
						{employee.loanDeductions.length > 0 && (
							<>
								<FlexButton title="Loans" mb={2} onClick={showLoans} />
								{loans &&
									employee.loanDeductions.map((loan, index) => (
										<div key={index} className={styles.employee__details}>
											<MimaText labelTitle="Disbursed Amount" mb={2}>
												{amountFormatter().format(loan.amountCollected)}
											</MimaText>
											<MimaText labelTitle="Repayment made" mb={2}>
												{amountFormatter().format(
													loan.amountCollected - loan.amountLeft
												)}
											</MimaText>
											<MimaText labelTitle="Repayment left" mb={2}>
												{amountFormatter().format(loan.amountLeft)}
											</MimaText>
											<MimaText labelTitle="Disbursement date" mb={2}>
												{loan.disbursementDate
													? moment(loan.disbursementDate).format('DD-MM-YYYY')
													: ''}
											</MimaText>
											<MimaText labelTitle="Most recent repayment date" mb={2}>
												{moment(loan.lastPayDate).format('DD-MM-YYYY')}
											</MimaText>
											<MimaText labelTitle="Total Repayment Cycles" mb={2}>
												{loan.rePaymentMonths}
											</MimaText>
											<MimaText labelTitle="Remaining Repayment Cycles" mb={2}>
												{loan.rePaymentMonthsLeft}
											</MimaText>

											<MimaText labelTitle="Status" mb={2}>
												{loan.status}
											</MimaText>
										</div>
									))}
							</>
						)}

						{employee.status !== 'TERMINATED' ? (
							<>
								{permissions.has(
									'CAN CREATE BUSINESS ADMIN AND SET PERMISSIONS'
								) && (
									<MimaButton
										title={
											employee?.user?.isBusinessAdmin
												? 'Edit Admin Access'
												: 'Give Admin Access'
										}
										buttonColor="var(--color-green)"
										mt={3}
										mb={3}
										onClick={showEmployeeAdmin}
									/>
								)}
								<MimaButton
									title={
										employee.status === 'SUSPENDED'
											? 'Cancel Suspension'
											: 'Suspend Employee'
									}
									buttonColor="var(--color-dark)"
									mb={3}
									onClick={() => showTerminate('Suspend')}
								/>

								<MimaButton
									title="Terminate Employee"
									onClick={() => showTerminate('Terminate')}
								/>
							</>
						) : (
							''
						)}
					</>
				)}

			{terminate && (
				<>
					<MimaText variant="subtitle" mb={4}>
						{terminateStatus} Contract
					</MimaText>
					<MimaText color="var(--color-error)" mb={2} width={38} align="center">
						{`Confirm that these details match the employee, you want to ${
							terminateStatus === 'Suspend'
								? 'cancel their suspension'
								: terminateStatus
						}`}
					</MimaText>
					<MimaText labelTitle="Employee Name" mb={2} width={38}>
						{`${employee.user.firstname} ${employee.user.lastname}`}
					</MimaText>
					<MimaText labelTitle="Job Title" mb={3} width={38}>
						{employee.jobTitle}
					</MimaText>

					<MimaButton title="Confirm" onClick={next} />
				</>
			)}

			{terminate2 && (
				<>
					<MimaText variant="subtitle" mb={4}>
						Terminate Contract
					</MimaText>
					<MimaText variant="smallBold" color="var(--color-primary)" mb={2}>
						Why is {`${employee.user.firstname} ${employee.user.lastname}`}{' '}
						being terminated?
					</MimaText>
					<Formik
						initialValues={{
							terminationDate: '',
							reason: '',
							otherReason: '',
						}}
						validationSchema={validationTerminationSchema()}
						onSubmit={onSubmit}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => (
							<>
								<div className={styles.employee__terminate}>
									<RCB
										title="Resignation"
										id="resignation"
										name="terminationReason"
										onChange={() => {
											setFieldValue('reason', 'Resignation');
										}}
										checked={values.reason === 'Resignation'}
										value="Resignation"
									/>
									<RCB
										title="Death"
										id="Death"
										name="reason"
										onChange={() => {
											setFieldValue('reason', 'Death');
										}}
										checked={values.reason === 'Death'}
										value="Death"
									/>
									<RCB
										title="Termination"
										id="Termination"
										name="reason"
										onChange={() => {
											setFieldValue('reason', 'Termination');
										}}
										checked={values.reason === 'Termination'}
										value="Termination"
									/>
									<RCB
										title="Retrenchment"
										id="Retrenchment"
										name="reason"
										onChange={() => {
											setFieldValue('reason', 'Retrenchment');
										}}
										checked={values.reason === 'Retrenchment'}
										value="Retrenchment"
									/>

									<RCB
										title="Retiring"
										id="Retiring"
										name="reason"
										onChange={() => {
											setFieldValue('reason', 'Retiring');
										}}
										checked={values.reason === 'Retiring'}
										value="Retiring"
									/>
									<RCB
										title="Other"
										id="Other"
										name="reason"
										onChange={() => {
											setFieldValue('reason', 'Other');
										}}
										checked={values.reason === 'Other'}
										value="Other"
									/>
								</div>
								{errors.reason ? (
									<div className={styles.error}>
										{''}
										{touched.reason && errors.reason}
										{''}
									</div>
								) : null}

								<MimaInput
									type="text"
									labelTitle="If reason is other"
									placeholder="enter other reason here"
									name="otherReason"
									id="otherReason"
									value={values.otherReason}
									onChange={handleChange}
									onBlur={handleBlur}
									mt={2}
								/>
								<MimaInput
									type="date"
									labelTitle="Termination Start date"
									placeholder="DD/MM/YY"
									name="terminationDate"
									value={values.terminationDate}
									onChange={handleChange}
									onBlur={handleBlur}
									error={errors.terminationDate}
									touched={touched.terminationDate}
								/>
								<MimaButton
									title={terminateStatus}
									type="submit"
									loading={loading}
									onClick={handleSubmit}
								/>
							</>
						)}
					</Formik>
				</>
			)}
			{suspension && (
				<>
					<MimaText variant="subtitle" mb={4}>
						Suspend {`${employee.user.firstname} ${employee.user.lastname}`}
					</MimaText>
					<MimaText variant="smallBold" color="var(--color-primary)" mb={2}>
						Why is {`${employee.user.firstname} ${employee.user.lastname}`}{' '}
						being suspended?
					</MimaText>
					<Formik
						initialValues={{
							suspensionStartDate: '',
							suspensionEndDate: '',
							reason: '',
						}}
						validationSchema={validationSuspensionSchema()}
						onSubmit={onSubmit}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							values,
							errors,
							touched,
						}) => (
							<>
								<MimaInput
									labelTitle="Suspension reason"
									type="text"
									placeholder="Enter reason"
									id="reason"
									name="reason"
									value={values.reason}
									onChange={handleChange}
									onBlur={handleBlur}
									error={errors.reason}
									touched={touched.reason}
								/>
								<MimaInput
									type="date"
									labelTitle="Suspension Start date"
									placeholder="DD/MM/YY"
									name="suspensionStartDate"
									value={values.suspensionStartDate}
									onChange={handleChange}
									onBlur={handleBlur}
									error={errors.suspensionStartDate}
									touched={touched.suspensionStartDate}
								/>

								<MimaInput
									type="date"
									labelTitle="Suspension End date"
									placeholder="DD/MM/YY"
									name="suspensionEndDate"
									value={values.suspensionEndDate}
									onChange={handleChange}
									onBlur={handleBlur}
									error={errors.suspensionEndDate}
									touched={touched.suspensionEndDate}
								/>

								<MimaButton
									title={terminateStatus}
									type="submit"
									loading={loading}
									onClick={handleSubmit}
								/>
							</>
						)}
					</Formik>
				</>
			)}
			{editState && (
				<EditEmployeeContainer
					closeModal={closeModal}
					stage2={stage2}
					stage3={stage3}
					showStage2={showStage2}
					showStage3={showStage3}
					showEditSuccess={showEditSuccess}
					showStage1={showStage1}
					success={success}
				/>
			)}

			{makeAdmin && <PermissionListContainer closeModal={closeModal} />}
		</Modal>
	);
};

export default SpecificEmployee;
